import { render } from "./smart-recommendation.vue?vue&type=template&id=5d973d50&scoped=true"
import script from "./smart-recommendation.js?vue&type=script&lang=js&external"
export * from "./smart-recommendation.js?vue&type=script&lang=js&external"

import "./smart-recommendation.vue?vue&type=style&index=0&id=5d973d50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d973d50"]])

export default __exports__